module.exports = __webpack_public_path__ + "img/xls.7952a4fd.png";